import {
  ICancelScheduledEventParams,
  ICreateScheduledEventParams,
  IGetScheduledEventInviteesParams,
  IInvitees,
  IScheduledEventDetails,
  IScheduledEventsList,
} from '@gem/models/scheduledEventModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from '../error/errorBuilder';

// Needs Bff implementation
export const getScheduledEventDetails = async (
  eventId: string
): Promise<IScheduledEventDetails> => {
  try {
    return {} as IScheduledEventDetails;
  } catch (error) {
    logger.get('API').error('scheduledEvents.getScheduledEvent', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const createScheduledEvent = async (
  props: ICreateScheduledEventParams
): Promise<IScheduledEventDetails> => {
  try {
    return {} as IScheduledEventDetails;
  } catch (error) {
    logger.get('API').error('scheduledEvents.createScheduledEvent', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getScheduledEvents = async (props: {
  cursor: string | undefined;
}): Promise<IScheduledEventsList> => {
  try {
    return {} as IScheduledEventsList;
  } catch (error) {
    logger.get('API').error('scheduledEvents.getScheduledEvents', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getScheduledEventInvitees = async (
  params: IGetScheduledEventInviteesParams
): Promise<IInvitees> => {
  try {
    return {} as IInvitees;
  } catch (error) {
    logger.get('API').error('scheduledEvents.getScheduledEventInvitees', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const cancelScheduledEvent = async (params: ICancelScheduledEventParams): Promise<void> => {
  try {
    return;
  } catch (error) {
    logger.get('API').error('scheduledEvents.cancelScheduledEvent', error);
    throw buildModelError(error);
  }
};
